export const queryChangelog = groq`*[_type == 'changelog' && currentPathname == $currentPathname][0]{
  ...,
  entries[] {
    reference->,
  },
}`;
